 <template>
    <div>
        <InicioSuperAdmins v-if="usuarioActual?.nivel === 1" />
        <InicioAdmins v-if="usuarioActual?.nivel === 2" />
        <InicioClientes v-if="usuarioActual?.nivel === 3" />
        <InicioProveedores v-if="usuarioActual?.nivel === 4" />
        <InicioProveedoresPDV v-if="pdvActual?.id" />
        <InicioUsuarios v-if="usuarioActual?.nivel === 6" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InicioSuperAdmins from './InicioSuperAdmins.vue'
import InicioAdmins from './InicioAdmins.vue'
import InicioClientes from './InicioClientes.vue'
import InicioProveedores from './InicioProveedores.vue'
import InicioProveedoresPDV from './InicioProveedoresPDV.vue'
import InicioUsuarios from './InicioUsuarios.vue'

export default {
    components: { InicioSuperAdmins, InicioAdmins, InicioClientes, InicioProveedores, InicioProveedoresPDV, InicioUsuarios },
    data() {
        return {}
    },
    computed: {
        ...mapGetters('auth', ['usuarioActual', 'pdvActual']),
    },
}
</script>

<style lang="scss" scoped>
</style>
